import React, {useState} from "react";
import alts from "configs/alts";
import SkeletonC from "./Skeletons/SkeletonC";
import clg from "functions/log";
import settings from "configs/settings";

const Img = ( props ) => {

    const [isLoaded, setIsLoaded] = useState(false);

    const splittedByDot = props.src.split(".");
    let src = splittedByDot[0] + "." + [splittedByDot[2]];
    const splittedBySlash = src.split("/");
    src = splittedBySlash[ splittedBySlash.length -1 ]

    const getAlt = () => {
        if( alts.hasOwnProperty(src) ) {
            return alts[src];
        }
        return alts.default;
    }

    const createAltPostfix = () => {
        const variants = settings.imageAltPostfix; //(array)
        const alt = variants[Math.floor(Math.random()*variants.length)];
        return alt;
    }

    let propsWithoutSkeletonConfig = {...props};

    delete propsWithoutSkeletonConfig["skeletonprops"];
    delete propsWithoutSkeletonConfig["skeletonThemeprops"];

    return(
        <>
            {
                !isLoaded && (
                    <SkeletonC skeletonProps={props.skeletonprops} skeletonThemeprops={props.skeletonthemeprops}/>
                )
            }
            <img {...propsWithoutSkeletonConfig} alt={ `${createAltPostfix()}${( props.alt ? props.alt : getAlt() )}` } onLoad={ () => setIsLoaded(true) }/>
        </>
    );
}

export default Img;